import React from "react";
import P from "../lib/P";
import Btn from "./Btn";
import Fontisto from '@expo/vector-icons/Fontisto';
import MainStyle from "../../MainStyle";

type Props = { title: string, subtitle: string, onPress?: () => void, selected?: boolean, disabled?: boolean };

const ModeSelect = (props: Props) => {
  const {title, subtitle, selected, disabled} = props;

  return (
    <Btn py={10} px={20} gap={5} rounded={8} borderWidth={2} borderColor={selected ? '#3369FF' : '#252526'} bg="#252526"
         onPress={props.onPress} disabled={disabled} opacity={disabled ? 0.5 : 1} justifyContent="center">
      <P fontFamily="DavisSans-Medium" ta="center">{title}</P>

      {disabled ? (
        <Fontisto name="locked" size={18} color="white" style={[MainStyle.absolute, MainStyle.r_15]}/>
      ) : (
        <P fontFamily="DavisSans-Regular" ta="center">{subtitle}</P>
      )}
    </Btn>
  );
};

export default ModeSelect;
